import { render, staticRenderFns } from "./create-group-folder.vue?vue&type=template&id=6f34189b&scoped=true&"
import script from "./create-group-folder.vue?vue&type=script&lang=js&"
export * from "./create-group-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f34189b",
  null
  
)

export default component.exports